import React from "react";
import Button from "../../Button";
import { Field, reduxForm } from "redux-form";
import { FormHelperText } from "material-ui/Form";
import TextField from "../../FormElements/TextField";
import { required } from "../../../util/formValidations";
import OverlayLoader from "../../OverlayLoader";

const CollectionForm = props => {
  const { handleSubmit, submitting, error } = props;
  return (
    <form className="form" onSubmit={handleSubmit}>
      {submitting && <OverlayLoader />}
      <span>Choose a name for your collection</span>
      <Field name="collectionName" component={TextField} label="collection name" validate={[required]} />
      <FormHelperText error>{error}</FormHelperText>
      <Button value="Save" type="submit" />
    </form>
  );
};

export default reduxForm({ form: "collectionModalForm" })(CollectionForm);



// WEBPACK FOOTER //
// ./src/components/CollectionFormModal/components/CollectionForm.js